import React from 'react';
import { Link } from 'react-router-dom';
import CommentsCountIcon from '../../CommentsCountIcon/CommentsCountIcon';

import './BlogPostMetaTitle.css';

const BlogPostMetaTitle = ({
  blogPost,
  titleLinkTo,
  commentsCountIconLinkTo,
}) => {
  const commentCount = blogPost.comments ? blogPost.comments.length : 0;

  const formattedDate = blogPost.publishedAt
    ? new Date(blogPost.publishedAt).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC',
      })
    : '';

  return (
    <div className='blog-post-meta-title-container'>
      <h3>
        {titleLinkTo ? (
          <Link to={titleLinkTo}>{blogPost.title}</Link>
        ) : (
          <span>{blogPost.title}</span>
        )}
      </h3>
      <div className='blog-post-meta-container'>
        <p>
          {`By `}
          <Link to={`/blog/author/${blogPost?.author?.slug}`}>
            {blogPost?.author?.name}
          </Link>
          {` on ${formattedDate} `}
          {Array.isArray(blogPost.categories) &&
            !!blogPost.categories.length && (
              <span>
                {`in `}
                {blogPost.categories?.map((category, i) => (
                  <span key={category._id}>
                    <Link to={`/blog/category/${category.slug}`}>
                      {category.name}
                    </Link>
                    {i < blogPost.categories.length - 1 && ', '}
                  </span>
                ))}
              </span>
            )}
        </p>

        <CommentsCountIcon linkTo={commentsCountIconLinkTo}>
          {commentCount}
        </CommentsCountIcon>
      </div>
    </div>
  );
};

export default BlogPostMetaTitle;
